import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { UnitsOfMeasurement } from '../../../schemas/units-of-measurement.schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { routingProfileServiceEnvironment } from '../routing-profile-service-environment';
import { defaultRoutingProfileSchema } from '../schemas/default-routing-profile.schema';
import { vehicleDimensionsThresholdSchema } from '../schemas/vehicle-dimensions-threshold.schema';

/**
 * Get a list of default routing profiles and vehicle dimension thresholds in the specified measurement format
 * @param units The unit of measurement format
 * @returns A list of default routing profiles and a list of vehicle dimension thresholds
 */
export function getRoutingProfilesDefault(
  this: unknown,
  units: UnitsOfMeasurement
) {
  const params = new URLSearchParams([
    ['units', units === 'Imperial' ? '0' : '1'],
  ]);
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          routingProfileServiceEnvironment.resolve(this)
            .routingProfilesDefaultUrl
        }?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        data: z.object({
          profiles: z.array(defaultRoutingProfileSchema),
          vehicleDimensionMinMax: z.array(vehicleDimensionsThresholdSchema),
        }),
      })
    )
  );
}
